import { render, staticRenderFns } from "./PasswordView.vue?vue&type=template&id=0b670d5e&"
import script from "./PasswordView.vue?vue&type=script&lang=js&"
export * from "./PasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports